import { useEffect } from 'react';

import { type ElementInfo } from '../types';

type UseElementInspectorProps = {
  isInspecting: boolean;
  setElementInfo: (info: ElementInfo | null) => void;
};

export const useElementInspector = ({ isInspecting, setElementInfo }: UseElementInspectorProps) => {
  useEffect(() => {
    if (!isInspecting) {
      setElementInfo(null);
      return;
    }

    const onMove = (e: MouseEvent) => {
      try {
        const target = document.elementFromPoint(e.clientX, e.clientY);
        if (!target || !(target instanceof HTMLElement)) return;

        const rect = target.getBoundingClientRect();
        const cs = getComputedStyle(target);

        setElementInfo({
          tagName: target.tagName.toLowerCase(),
          className: target.className || '',
          id: target.id || '',
          dimensions: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
          },
          position: {
            x: Math.round(rect.left),
            y: Math.round(rect.top),
          },
          styles: {
            margin: cs.margin,
            padding: cs.padding,
            border: cs.border,
            borderWidth: cs.borderWidth,
            marginTop: cs.marginTop,
            marginRight: cs.marginRight,
            marginBottom: cs.marginBottom,
            marginLeft: cs.marginLeft,
            paddingTop: cs.paddingTop,
            paddingRight: cs.paddingRight,
            paddingBottom: cs.paddingBottom,
            paddingLeft: cs.paddingLeft,
            background: cs.backgroundColor,
            gap: cs.gap,
            display: cs.display,
            gridGap: cs.gridGap,
            columnGap: cs.columnGap,
            rowGap: cs.rowGap,
          },
        });
      } catch (error) {
        console.warn('[DevModal] Error inspecting element:', error);
        setElementInfo(null);
      }
    };

    document.addEventListener('mousemove', onMove);
    return () => document.removeEventListener('mousemove', onMove);
  }, [isInspecting, setElementInfo]);
};
